// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"881":"01a98477","1180":"01a98477","3251":"9b79cbba","3616":"01a98477","5255":"01a98477","5491":"01a98477","6985":"01a98477","8488":"86454a2c"}[chunkId] + ".chunk.css";
};